export default function(str, options) {
  return encodeURIComponent(str);
}
